<template>
    <v-container class="ma-0 pa-0 mt-6">
        <v-row dense class="ma-0 pa-0 d-flex justify-space-around tab_title">
            <v-col cols="4" align="center" class="ma-0 pa-0" @click="goDisease">
                <span :class="title === '0' ? ' underline' : ''" >질환 분석 </span>
            </v-col>
            <v-col cols="4" align="center" class="ma-0 pa-0" @click="goExercise"> 
                <span :class="title === '1' ? ' underline' : ''">운동 가이드 </span>
            </v-col>
            <v-col cols="4" align="center" class="ma-0 pa-0" @click="goDiet"> 
                <span :class="title === '2' ? ' underline' : ''">식이 가이드 </span>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                currentTitle: ''
            }
        },
        props: {
            title: {
                type: String,
                defalut: '0'
            },
        },
        computed: {
            getDate() {
                return '발행일 : ' + this.date
            }
        },
        methods: {
            goDisease() {
                console.log(this.title)
                if(this.title !== "0")
                    this.$router.push("/checkup/guideDisease")
            },
            goExercise() {
                this.$router.push("/checkup/guideExercise")
            },
            goDiet() {
                this.$router.push("/checkup/guideDiet")
            }
        },
        mounted() {

        }
    }
</script>
<style scoped>
    .tab_title {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 14px;
        letter-spacing: -0.67px;
        color: #193263;
    }  

    .nav-guide {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
    }
    .nav-control {
        text-align: center;
        border-radius: 28px;
        height: 56px;
        line-height: 56px;
        vertical-align: middle;
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;;
        font-size: 1.35rem;
        color: white;
        border-radius: 28px;
        box-shadow: 0 8px 20px -4px rgba(63, 111, 255, 0.5);
        background-color: #3f6fff;
        margin-bottom: 14px;
        position: relative;
    }
    .btn-left-arrow {
        display: inline-block;
        position: absolute;
        margin-top: 15px;
        left: 50px;
        width: 24px;
    }
    .btn-right-arrow {
        display: inline-block;
        position: absolute;
        margin-top: 15px;
        right: 50px;
        width: 24px;
    }
    .section-title {
        display: inline-block;
        color: white;
    }
    .date {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        text-align: center;
        color: #888888;
        margin-bottom: 28px;
    }

    img {
        outline: none;
    }

    img:focus-visible {
        outline: #1e1e1e solid 3px;
    }

    .underline {
        text-decoration: underline;
        text-decoration-color: #00b1ff;
        text-decoration-thickness: 3px;
        text-underline-position: under;
    }
</style>
